import { EsnEvaluationService } from './../../../../core/services/esn-evaluation/esn-evaluation.service';
import {
  NgSignaturePadOptions,
  SignaturePadComponent,
} from '@almothafar/angular-signature-pad';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  serverError,
  successSignature,
} from './../../../../core/models/messages';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-question',
  templateUrl: './add-question.component.html',
  styleUrls: ['./add-question.component.css'],
})
export class AddQuestionComponent {
  @ViewChild('signature', { static: true })
  signaturePad!: SignaturePadComponent;
  chapitreList: { name: string }[] = [];
  esn_id!: string | null;
  evaluation_id!: string;
  chapitreDetails: any;
  modalRef?: BsModalRef;
  file: any;
  fileError: string = '';
  fileExtention: string = '';
  formPV: FormGroup = this.createPVForm();
  type = [
    { id: 1, name: 'Annuelle' },
    { id: 2, name: 'Suivi' },
    // { id: 3, name: 'Trimestre'},
  ];
  signatureFile: any;
  public signaturePadOptions: NgSignaturePadOptions = {
    minWidth: 1,
    canvasWidth: 300,
    canvasHeight: 250,
    backgroundColor: '#ffffff',
  };
  signed = [
    { id: 2, name: 'Signé par l’ESN' },
    { id: 1, name: 'Signé par candidat' },
  ];

  id: any;
  formData = new FormData();
  private signatureDataUrl: string | null = null;
  // unsubscription
  evaluation_send_id!: string;
  constructor(
    private formBuilder: FormBuilder,
    private evaluationservice: EsnEvaluationService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.getIdPv();
    console.log('id', this.getIdPv());
  }
  createPVForm(data?: any) {
    return this.formBuilder.group({
      evaluation_send_id: [''],
      report: ['', data && data.report],
    });
  }
  closeModal() {
    this.modalRef?.hide();
    // this.createQuestionForm.reset()
    // this.formData = new FormData()
    this.file = null;
    this.fileError = '';
    this.fileExtention = '';
  }
  getIdPv() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.id = params.params['id'];
      },
    });
  }
  ngAfterViewInit() {
    this.signaturePad.set('minWidth', 1);
    this.signaturePad.clear();
  }

  //////////////////////////////////////////////////////////////////////////////////
  drawComplete() {
    console.log('Completed drawing', event);
    this.signatureDataUrl = this.signaturePad?.toDataURL();
    console.log('Signature Data URL:', this.signatureDataUrl);
    const blob = this.dataURLToBlob(this.signatureDataUrl);
    this.signatureFile = new File([blob], 'signature.png');
    console.log('this.signatureFilethis.signatureFile', this.signatureFile);
  }

  dataURLToBlob(dataURL: string): Blob {
    const arr = dataURL?.match(/:(.*?);/);
    if (arr && arr[1]) {
      const mime = arr[1];
      const bstr = atob(dataURL?.split(',')[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr?.charCodeAt(n);
      }

      return new Blob([u8arr], { type: mime });
    } else {
      console.error('Failed to determine MIME type from data URL:', dataURL);
      return new Blob();
    }
  }
  drawStart(event: MouseEvent | Touch) {
    console.log('Start drawing', event);
  }
  clearSignature() {
    console.log('signaturePadsignaturePadsignaturePad', this.signaturePad);
    this.signaturePad?.clear();
  }
  downloadSignature() {
    this.signatureDataUrl = this.signaturePad?.toDataURL();
    this.convertBase64ToImage(this.signatureDataUrl);
  }
  convertBase64ToImage(base64Data: string) {
    const image = new Image();
    image.src = base64Data;

    const downloadLink = document.createElement('a');
    downloadLink.href = base64Data;
    downloadLink.download = 'signature.png';

    const container = document.getElementById('imageContainer');
    if (container) {
      container.innerHTML = '';
      container.appendChild(image);
      container.appendChild(downloadLink);
      downloadLink.click();
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////
  sendSignature() {
    this.spinner.show();
    this.signatureDataUrl = this.signaturePad?.toDataURL();
    console.log('Signature Data URL:', this.signatureDataUrl);

    const blob = this.dataURLToBlob(this.signatureDataUrl);
    this.signatureFile = new File([blob], 'signature.png');

    if (!this.signatureFile) {
      console.error('No signature file selected.');
      this.spinner.hide();
      return;
    }

    this.formData.append('signature_file_esn', this.signatureFile);
    this.evaluationservice.addSignature(this.id, this.formData).subscribe(
      (response) => {
        console.log('Signature sent to the backend successfully', response);
        this.toastrService.success(successSignature);
        this.spinner.hide();
        this.router.navigateByUrl(
          `/evaluation/details-pv;id=${this.id}`
        );
      },
      (error) => {
        this.spinner.hide();
        this.toastrService.error(serverError);
        console.error('Error sending signature to the backend', error);
      }
    );
  }
}
